module.exports = "/call-frontend/img/menu_bg_light.77705fe4.png";